// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"91cae17c","879":"d3ff97c6"}[chunkId] + ".chunk.js";
};